import axios from 'axios';
import { getLocalValue } from '../utils/local-cache.util';
import { LS_ADMIN_USER_AUTH_TOKEN } from '../config/const.config';

const prepareRequestOptions = (url, method, data = null, signal = null) => {
  const baseAPIUrl = process.env.REACT_APP_ANALYTICS_API_ENDPOINT;
  const credentials = process.env.REACT_APP_ANALYTICS_API_CREDENTIALS;
  const adminAuth = getLocalValue(LS_ADMIN_USER_AUTH_TOKEN);
  const offset = new Date().getTimezoneOffset();

  const options = {
    url: `${baseAPIUrl}${url}`,
    method,
    headers: {
      'Content-Type': 'application/json',
      'X-Reports-Data': credentials,
      'X-Admin-Auth-Token': adminAuth,
      'X-Timezone-Offset': offset,
    },
    data: JSON.stringify(data || {}),
  };

  if (signal) {
    options.signal = signal;
  }

  return options;
};

export const getReportsData = async (payload, signal = null) => {
  const options = prepareRequestOptions(
    '/reports/export',
    'POST',
    payload,
    signal
  );

  const response = await axios(options);
  return response.data;
};

export const getRealtimeDashboard = async (payload, signal = null) => {
  const options = prepareRequestOptions(
    '/reports/realtime-dashboard',
    'POST',
    payload,
    signal
  );

  const response = await axios(options);
  return response.data;
};

export const getVideos = async () => {
  const options = prepareRequestOptions('/reports/list/videos', 'GET');

  const response = await axios(options);
  return response.data;
};

export const getDataList = async (type, signal = null) => {
  const options = prepareRequestOptions(
    `/reports/data/${type}`,
    'GET',
    null,
    signal
  );

  const response = await axios(options);
  return response.data;
};

export const getCounters = async () => {
  const options = prepareRequestOptions('/reports/counters', 'GET');

  const response = await axios(options);
  return response.data;
};

export const getSessionDetails = async (id) => {
  const options = prepareRequestOptions(`/reports/session/${id}/view`, 'GET');

  const response = await axios(options);
  return response.data;
};

export const getAppSessionDetails = async (id) => {
  const options = prepareRequestOptions(
    `/reports/app-session/${id}/view`,
    'GET'
  );

  const response = await axios(options);
  return response.data;
};

export const getWebTotalSubscriber = async (payload) => {
  const options = prepareRequestOptions(
    `/reports/web-total-subscriber`,
    'POST',
    payload
  );
  const response = await axios(options);
  return response.data;
};
export const getWebSubscriberSummary = async (payload) => {
  const options = prepareRequestOptions(
    `/reports/web-subscriber-summary`,
    'POST',
    payload
  );
  const response = await axios(options);
  return response.data;
};

export const getWebSubscriptionsList = async (params, signal = null) => {
  const options = prepareRequestOptions(
    `/reports/web-subscription-list${params}`,
    'GET',
    null,
    signal
  );

  const response = await axios(options);
  return response.data;
};

export const viewWebSubscriptionsById = async (id, signal = null) => {
  const options = prepareRequestOptions(
    `/reports/web-subscription/${id}/view`,
    'GET',
    null,
    signal
  );

  const response = await axios(options);
  return response.data;
};
